export const HTML_TAGS = [
  'html',
  'head',
  'body',
  'div',
  'span',
  'a',
  'img',
  'video',
  'audio',
  'source',
  'button',
  'input',
  'form',
  'label',
  'select',
  'option',
  'textarea',
  'table',
  'tr',
  'td',
  'th',
  'thead',
  'tbody',
  'tfoot',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'br',
  'hr',
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'strike',
  'pre',
  'code',
  'blockquote',
  'cite',
  'q',
  'abbr',
  'acronym',
  'address',
  'del',
  'ins',
  'sub',
  'sup',
  'small',
  'big',
  'tt',
  'dfn',
  'kbd',
  'samp',
  'var',
  'mark',
  'ruby',
  'rt',
  'rp',
  'bdi',
  'bdo',
  'wbr',
  'details',
  'summary',
  'menu',
  'menuitem',
  'menuitem',
  'figure',
  'figcaption',
  'main',
  'article',
  'section',
  'aside',
  'header',
  'footer',
  'nav',
  'dialog',
  'meter',
  'progress',
  'canvas',
  'svg',
  'math',
  'iframe',
  'embed',
  'object',
  'param',
  'source',
  'track',
  'area',
  'map',
  'iframe',
  'frame',
  'frameset',
  'noframes',
  'noscript',
  'style',
  'link',
  'meta',
  'title',
  'base',
  'script',
  'noscript',
  'template',
]
